import { fetchPaxsGroup, sendSMSshareroom } from '@/api/passenger'
import { fetchListHotel } from '@/api/service'

const getPaxsGroup = (context) => {
  return fetchPaxsGroup().then((response) => {
    context.commit('PAXSGROUP_UPDATED', response)
    return response
  })
}

const searchHotels = (context, payload) => {
  return fetchListHotel(payload).then((response) => {
    return response
  })
}

const sendSMSShareroom = (context, payload) => {
  return sendSMSshareroom(payload).then((response) => {
    return response
  })
}

export default {
  getPaxsGroup,
  searchHotels,
  sendSMSShareroom
}
